const getXmlFromUrl = async url => {
  const response = await window.fetch(url);
  if (!response.ok)
    throw new Error(`Failed to fetch XML from ${url}: Status ${response.status} ${response.statusText}`);
  const xml = await response.text();
  return xml;
};

export default getXmlFromUrl;
